/**
 * Formats a full account name into separated first and last names.
 * @param accountName - The full account name string
 * @returns Object with firstName and lastName properties
 */
export function formatDisplayName(accountName: string) {
    const parts = accountName.trim().split(/\s+/).filter(Boolean)

    return {
        firstName: parts[0] || '—',
        lastName: parts.length > 1 ? parts.slice(1).join(' ') : '—',
    }
}
